import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Button, Checkbox, Form } from 'formik-semantic-ui';
import * as Yup from 'yup';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwTestResultModalValues {
  testPassed: boolean;
}

const PtwTestResultSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    testPassed: Yup.boolean().oneOf([true], t('Field must be checked')),
  });

interface PtwTestResultModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: (values: PtwTestResultModalValues) => void;
}

class PPtwTestResultModal extends Component<PtwTestResultModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Conferma collaudo'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Testing result'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ testPassed: false }}
            validationSchema={PtwTestResultSchema(t)}
            onSubmit={this.props.onSubmit}
          >
            <Checkbox name={'testPassed'} label={t('Spuntando la casella')} />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwTestResultModal = withTranslation()(PPtwTestResultModal);
